import { OnInit, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DashboardService } from 'src/app/core/services/dashboard/dashboard.service';
import { UserService } from 'src/app/core/user/user.service';

@Component({
  selector: 'app-modal-offres',
  templateUrl: './modal-offres.component.html',
  styleUrls: ['./modal-offres.component.scss'],
})
export class ModalOffresComponent implements OnInit {
  @Input() bien: any;
  @Input() nbOffres: any;
  @Input() colorIcon = 'white';

  userConnected?: any = {};
  OfferData: any;
  isLoadedHttp = false;

  messageConfirmation: any = '';
  statusConfirmation = 'success';
  showAlert = false;

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private _userService: UserService,
    private _dashboardService: DashboardService
  ) {}

  ngOnInit() {
    this.userConnected = this._userService.getUser();
  }

  getDataOffers() {
    this.isLoadedHttp = false;
    this._dashboardService
      .getAchatOffres(this.bien.id)
      .subscribe((response: any) => {
        this.OfferData = response['data'];
        this.isLoadedHttp = true;
      });
  }

  openVertically(content: any) {
    this.OfferData = [];
    this.getDataOffers();
    this.showAlert = false;
    this.messageConfirmation = '';
    this.modalService.open(content, { size: 'xl' });
  }

  responseOffer(responseO: any, offre: any) {
    this._dashboardService
      .setOfferResponse(offre.id, responseO)
      .subscribe((response: any) => {
        if (response['data'].length > 0) {
          this.modalService.dismissAll();
          this.messageConfirmation = 'Votre Réponse à bien été sauvegardé';
          this.showAlert = true;
        }
      });
  }
}
